import Vue from "vue";
import { errorServeiceHandler } from "../helper";

const actions = {
  actGetLogout: (context) => {
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + "/subscriber/v1/logout", {
        method: "GET"
      })
        .then(errorServeiceHandler)
        .then(response => {
            return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/logout.js